module.exports = __webpack_public_path__ + "static/img/y1.72e3c391.svg";